/**
 * Helper function to set parameters for table operations (sort, filter, pagination)
 * @param {Object} context - Component context (this)
 * @param {String} type - Parameter type (sort, filters, page, limit)
 * @param {String} key - Parameter key
 * @param {*} value - Parameter value
 * @param {String} operator - Filter operator (in, bt, eq)
 */
export const setParams = (context, type, key = "", value = "", operator = "") => {
  console.log("parasdasdms", context.props.params, type);

  let params = context.state.params.$clone(true);
  let find = false;
  let index = -1;
  key = window.app._.snakeCase(key);

  if (type === "sort" && key !== "") {
    const itemIndex = params.sort.findIndex((item) => item.key === key);

    if (itemIndex !== -1) {
      const sortItem = params.sort.splice(itemIndex, 1)[0];
      sortItem.direction = value;
      params.sort.unshift(sortItem);
      find = true;
      console.log(`Moved sort item with key ${key} to index 0`);
    }
  }

  for (let x in params) {
    if (x === type) {
      if (find && type === "sort") {
        continue;
      }

      window.app._.map(params[x], (param) => {
        index++;
        if (key !== "") {
          if (param && param.key && window.app._.snakeCase(param.key) === key) {
            find = true;
            if (
              (!window.app._.isArray(value) && window.app._.isEmpty(value)) ||
              (window.app._.isArray(value) &&
                (!value[0] || value[0] === "" || value[0] === null))
            ) {
              params[x].splice(index, 1);
            } else {
              if (operator === "") {
                param.direction = value;
              } else {
                param.value = value;
              }
            }
          }
        } else {
          if (value !== "") {
            if (param === value) {
              find = true;
            }
          }
        }
      });

      if (
        !find &&
        ((!window.app._.isArray(value) && value !== "") ||
          (window.app._.isArray(value) &&
            value[0] &&
            (value[0] !== "" || value[0] !== null)))
      ) {
        if (key !== "") {
          if (operator !== "") {
            if (operator === "bt") {
              key = window.app._.camelCase(key);
            }
            params[x].push({ key, value, operator });
          } else {
            params[x].push({ key, direction: value });
          }
        } else {
          params[x].push(value);
        }
      }
    }
  }

  if (!window.app._.isEqual(params, context.state.params)) {
    context.setState({ params }, () => {
      context.props.get(params);
    });
  }
};

/**
 * Get selected rows based on row keys
 * @param {Object} context - Component context (this)
 * @return {Array} Selected rows
 */
export const getRowSelected = (context) => {
  const { dataSource, rowKey } = context.props;
  const { selectedRowKeys } = context.state;

  return dataSource.filter((data) => {
    return selectedRowKeys.indexOf(data[rowKey]) > -1;
  });
};

/**
 * Calculate total table width based on column widths
 * @param {Object} context - Component context (this)
 * @return {Number} Total width
 */
export const calculateTableWidth = (context) => {
  const { columns } = context.props;
  const { selectedColumns } = context.state;
  let width = 100;

  if (window.app._.isEmpty(selectedColumns)) {
    window.app._.map(columns, (column) => {
      width += column.width ? parseInt(column.width) : 135;
    });
  } else {
    window.app._.map(selectedColumns, (column) => {
      width += column.width ? parseInt(column.width) : 135;
    });
  }

  return width;
};

/**
 * Determine row CSS classes based on conditions
 * @param {Object} item - Row data
 * @param {Object} context - Component context (this)
 * @return {String} CSS class names
 */
export const getRowClassName = (item, context) => {
  const { rowClassName, activeItem, printTitle } = context.props;
  const { onClickRows } = context.state;

  let classes = rowClassName || "";

  if (activeItem && item.id === activeItem) {
    classes += ` ant-table-row-hover ${item.className || ""}`;
  } else if (item.className) {
    classes += ` ${item.className}`;
  }

  if (
    item.key === onClickRows.key &&
    !!printTitle &&
    printTitle !== "گزارش تردد"
  ) {
    classes += " selected-sdfrow";
  }

  return classes?.trim();
};

/**
 * Export report with specific format
 * @param {Object} context - Component context (this)
 * @param {String} format - Export format (csv, xlsx, etc.)
 */
export const exportReport = (context, format) => {
  const { dataExport, columns } = context.props;
  const { selectedColumns, footerItems } = context.state;

  const JsonExport = require("./JsonExport").default;
  let exporter = new JsonExport(
    dataExport,
    columns,
    selectedColumns,
    footerItems
  );
  exporter.exportAs(format, "export");
};
